import { useQuery } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';
import { tenantLogoUrlFragment } from '@eluve/shared-gql-operations';

const getTenantLogoUrlQuery = graphql(
  `
    query getTenantLogoUrl($tenantId: uuid!) {
      tenantsByPk(id: $tenantId) {
        ...TenantLogoUrl
      }
    }
  `,
  [tenantLogoUrlFragment],
);

export const useTenantLogo = (tenantId: string) => {
  const { data, loading } = useQuery(getTenantLogoUrlQuery, {
    fetchPolicy: 'cache-first',
    variables: { tenantId },
  });

  return {
    loading,
    tenantLogoUrl: data?.tenantsByPk?.logoUrl ?? '',
  };
};
